// src/components/common/Focusable.js
// Filepath: // src/components/common/Focusable.js
import React, { useEffect, useRef } from "react";
import Box from "@mui/material/Box";

export default function Focusable({
  className = "",
  row = 0,
  col = 0,
  autoFocus = false,
  children,
  sx,
  ...rest
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (autoFocus && ref.current) {
      document.querySelectorAll(".focused").forEach(n => n.classList.remove("focused"));
      ref.current.classList.add("focused");
      ref.current.focus?.();
    }
  }, [autoFocus]);

  return (
    <Box
      ref={ref}
      tabIndex={-1}
      className={className}
      data-focusable="true"
      data-row={row}
      data-col={col}
      sx={sx}
      {...rest}
    >
      {children}
    </Box>
  );
}
